import { Injectable } from '@angular/core';
import { AdditionalService, ProductResp, ProductService } from '@cemex-core/cmx-api';
import { IProduct } from '@cemex-core/cmx-api/models/product/models/product.interface';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { map, switchMap, filter, catchError } from 'rxjs/operators';
import {
  OneClickOrdersActionTypes,
  OneClickSelectOrderAction,
} from '@ordersnproducts/modules/one-click-order/actions/one-click-orders.actions';
import {
  OneClickLoadAdditionalServicesAction,
  OneClickAdditionalServicesActionTypes,
  OneClickLoadAdditionalServicesCompleteAction,
  OneClickResetAdditionalServicesAction,
} from '@ordersnproducts/modules/one-click-order/actions/one-click-additional-services.actions';
import { SALES_DOCUMENT_TYPE_CODE } from '@ordersnproducts/modules/shared/constants/sales-document-type-code';
import { of } from 'rxjs';

@Injectable()
export class OneClickAdditionalServicesEffects {
  loadAdditionalServicesCommand = createEffect(() =>
    this.actions$.pipe(
      ofType(OneClickOrdersActionTypes.SELECT_ORDER),
      map((action: OneClickSelectOrderAction) => {
        return new OneClickLoadAdditionalServicesAction(action.payload);
      }),
    ),
  );

  getAdditionalServices = createEffect(() =>
    this.actions$.pipe(
      ofType(OneClickAdditionalServicesActionTypes.LOAD_ADITIONAL_SERVICES),
      map((action: OneClickLoadAdditionalServicesAction) => action.payload),
      filter((order) => !!order),
      switchMap((order) => {
        return this.productService
          .getAdditionalServices({
            shipmentLocationId: order.jobsite.jobsiteId,
            shippingConditionId: order.shippingCondition.shippingConditionId,
            productLineId: order.items[0].product.productType.productTypeId,
            salesAreaId: order.salesArea.salesAreaId,
            salesDocumentTypeCode: SALES_DOCUMENT_TYPE_CODE.ADDITIONAL_SERVICES,
          })
          .pipe(
            map((response: ProductResp) => {
              const additionalServices = this.productsToAdditionalServices(response.products);
              return new OneClickLoadAdditionalServicesCompleteAction(additionalServices);
            }),
            catchError((error) => of(new OneClickResetAdditionalServicesAction(error))),
          );
      }),
    ),
  );

  private productsToAdditionalServices(products: IProduct[]): AdditionalService[] {
    return products.map((product) => {
      return {
        additionalServiceCode: product.commercialCode,
        additionalServiceDesc: product.commercialDesc,
        additionalServiceLabel: product.additionalServiceLabel,
        additionalServiceId: product.product.productId,
      } as AdditionalService;
    });
  }

  constructor(
    private actions$: Actions,
    private productService: ProductService,
  ) {}
}
